module.exports = __webpack_public_path__ + "img/gabon.2a9abfb7.svg";